import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Button, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { useRecordHeader } from '../../hooks/use-record-header';
import * as Styled from './styles';
import * as SX from './sx';
import type { RecordManagementHeaderProps as Props } from './types';

export const RecordManagementHeader = memo(({ className, value }: Props) => {
  const { icon, route, title } = useRecordHeader(value);

  return (
    <Styled.Wrapper
      className={classnames('RecordManagementHeader', className)}
      sx={SX.root}
    >
      <Stack direction="row" alignItems="center" gap={1}>
        <Icon name={icon} color="primary.500" size={24} />

        <Typography variant="body3" color="grey.700" fontWeight={500}>
          {title}
        </Typography>
      </Stack>

      <Button
        variant="outlined"
        color="default"
        size="xsmall"
        component="a"
        href={route}
        target="_blank"
        rel="noopener noreferrer"
      >
        View all
      </Button>
    </Styled.Wrapper>
  );
});

RecordManagementHeader.displayName = 'RecordManagementHeader';
